module.exports = __webpack_public_path__ + "static/media/29DUNON2.ba32bb3f.jpg";